// Analytics data context exports
export {
	AnalyticsDataProvider,
	useAnalyticsData,
	type AnalyticsData,
} from './analytics-data-context';

// Web analytics client exports
export { devAnalyticsClient, devAIAnalyticsClient } from './client';
export { FireScreenEvent } from './fire-screen-event';
export {
	AnalyticsWebClientProvider,
	useAIAnalyticsWebClient,
	useAnalyticsWebClient,
} from './web-client-context';
export {
	useDevAIWebAnalyticsClient,
	useRovoDevWebAnalyticsClient,
} from './rovo-dev-web-analytics-events';

// AI Unified Event Instrumentation (wraps `@atlassian/ai-analytics` so AI
// events flow through the existing dev-agents track pipeline and inherit the
// same orgId / analyticsData enrichment as today's track events).
export { AIEventsInstrumentationProvider } from '@atlassian/ai-analytics';
export {
	useDevAgentsAIAnalytics,
	useDevAgentsAIAnalyticsConfig,
} from './ai/use-dev-agents-ai-analytics';
export type { DevAgentsAIAnalyticsConfig } from './ai/use-dev-agents-ai-analytics';
